import DayPickerInput from 'react-day-picker/DayPickerInput';
import { defaultProps } from 'react-recompose';
import 'react-day-picker/lib/style.css';
import './overrides.css';

export default defaultProps({
  todayButton: 'Today',
})(DayPickerInput);
